export const LOGIN_FAILED = 'Log-in attempt unsuccessful';